import { render, staticRenderFns } from "./ViewStudentsViaSections.vue?vue&type=template&id=5ff569f9&scoped=true"
import script from "./ViewStudentsViaSections.vue?vue&type=script&lang=js"
export * from "./ViewStudentsViaSections.vue?vue&type=script&lang=js"
import style0 from "./ViewStudentsViaSections.vue?vue&type=style&index=0&id=5ff569f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff569f9",
  null
  
)

export default component.exports